import { parseMarketDetailContent } from './marketDetailContent';

export const buildStaticMarketDetailContent = (market) => ({
  hero: {
    category: market.category,
    title: market.title,
    description: market.heroDescription,
    cta: {
      text: market.cta,
      url: '/create-account',
    },
    image: market.heroImage,
  },
  globalCompanies: {
    title: market.companiesTitle,
    paragraphs: market.companiesParagraphs,
    image: '',
  },
  marketSegments: {
    title: market.segmentsTitle,
    items: market.segments.map((item) => ({
      ...item,
      icon: item.icon || '',
    })),
  },
  featuredCompanies: {
    title: 'Featured Companies',
    items: market.featuredCompanies.map((item) => ({
      ...item,
      logo: item.logo || '',
    })),
  },
  marketAccess: {
    title: market.accessTitle,
    text: market.accessText,
    items: market.accessItems,
    cta: {
      text: market.accessCta,
      url: '/create-account',
    },
    checkIcon: '',
    image: '',
  },
  risk: {
    title: 'Risk Considerations',
    text: market.riskText,
    eagleImage: '',
  },
  start: {
    title: 'Start Investing in Global Markets.',
    text: 'Speak with our team to explore how VBS Finance Consulting can strengthen your financial operations and long-term readiness.',
    cta: {
      text: 'Open an Account',
      url: '/create-account',
    },
  },
});

export const resolveMarketDetailContent = (page, market) => {
  const parsed = parseMarketDetailContent(page);
  const fallback = buildStaticMarketDetailContent(market);

  if (!parsed) {
    return fallback;
  }

  return {
    hero: parsed?.hero
      ? {
          ...fallback.hero,
          ...parsed.hero,
          image: parsed.hero.image || fallback.hero.image,
        }
      : fallback.hero,
    globalCompanies: parsed.globalCompanies || fallback.globalCompanies,
    marketSegments: parsed.marketSegments || fallback.marketSegments,
    featuredCompanies: parsed.featuredCompanies || fallback.featuredCompanies,
    marketAccess: parsed.marketAccess || fallback.marketAccess,
    risk: parsed.risk || fallback.risk,
    start: parsed.start || fallback.start,
  };
};
